module.exports = __webpack_public_path__ + "img/wan-accelerator.2c242b1e.png";